<template>
  <div class="layout-footer">
    <div class="content">
      <div class="left">
        <div class="left-top">
          <img src="@/assets/img/Logo-AFCwave-footer.png" />
        </div>

        <div class="left-imgbox">
          <a :href="'http://service.weibo.com/share/share.php?appkey=583395093&title='+title+'&url='+fullUrl+'&bsh_bid=4640237236&source=bshare&retcode=0&ralateUid='"><img src="@/assets/img/footer/weibo.png" /></a>
          <a class="wechat-share" @click="qrcode()">
            <img src="@/assets/img/footer/wechat.png" />
            <div v-show="showCode" id="qrcode" ref="qrcode"></div>
          </a>
          <a><img src="@/assets/img/footer/jinritoutiao.png" /></a>
        </div>
      </div>
      <div class="middle">
        <div class="mid-box">
          <ul>
            <li>{{$t('Layout.Footer.Product')}}</li>
            <li v-for="(item, index) in proList"><router-link :to="{path: '/products', query: {'bid': item.cid}}">{{item.cname}}</router-link></li>
          </ul>
          <ul class="mid">
            <li>{{$t('Layout.Footer.Solutions')}}</li>
            <li v-for="(item, index) in solList"><router-link :to="{path: '/solutions', query: {'cid': item.id}}">{{item.category}}</router-link></li>
          </ul>
          <ul class="mid">
            <li>{{$t('Layout.Footer.Training')}}</li>
            <li><router-link tag="a" to="/training">{{$t('Layout.Footer.CourseInfo')}}</router-link></li>
            <li><router-link tag="a" to="/training/schedule">{{$t('Layout.Footer.CourseSchedule')}}</router-link></li>
          </ul>
          <ul>
            <li>{{$t('Layout.Footer.Resources')}}</li>
            <li v-for="(item, index) in resList"><router-link to="/resources">{{item.type_name}}</router-link></li>
          </ul>

          <div class="clear"></div>
        </div>
      </div>
      <div class="right">
        <div class="right-up">
          <p class="phone">{{$t('Layout.Footer.Tel')}}</p>
          <p class="phone2" >0755-28401165</p>
          <p class="worktime">{{$t('Layout.Footer.Everyday')}} 9:00-18:00</p>
          <p class="email">marketing@edcwifi.com</p>
        </div>
        <div class="right-bottom">
          <router-link to="/contact">{{$t('Layout.Footer.ContactUs')}}</router-link>
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import {GetFooterProducts, GetFooterSolutions, GetFooterResource} from '@/api/index.js'
import QRCode from 'qrcodejs2'
export default {
  name: 'LayoutFooter',
  data() {
    return {
      proList: [],
      solList: [],
      resList: [],
      fullUrl: window.location.href,
      title: window.document.title,
      showCode: false,
      myQrCode: null
    };
  },
  components: {

  },
  methods: {
    initData(){
      GetFooterProducts({}).then(res => {
        this.proList = res.data;
      })

      GetFooterSolutions({}).then(res => {
        this.solList = res.data;
      })

      GetFooterResource({}).then(res => {
        this.resList = res.data.list;
      })
    },
    qrcode(){
      this.showCode = !this.showCode;
      if(this.myQrCode != null){
        return;
      }
      this.myQrCode = new QRCode(this.$refs.qrcode, {
        width: 132,
        height: 132,
        text: this.fullUrl, // 二维码地址
        colorDark : "#000",
        colorLight : "#fff",
      })
    }
  },
  created(){
    this.initData();
  }
};
</script>

<style lang="" scoped>
.layout-footer{
  width: 100%;
  background-color: #f9f9f9;
  min-height: 260px;
  overflow: hidden;
}

.content{
  width: 88%;
  max-width: 1600px;
  margin: 30px auto;
}

.left{
  width: 20%;
  height: 260px;
  float: left;
}

.left-top{
  width: 100%;
  height: 60%;
  position: relative;
}

.left .left-top img{
  position: absolute;
  display: block;
  height: 60%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.left .left-imgbox{
  width: 100%;
  height: 40%;
  text-align: center;
}

.left .left-imgbox img{
  display: inline-block;
  width: 35px;
  height: 35px;
  margin: 12% 3px 0;
}

.middle{
  width: 62%;
  float: left;
}

.mid-box{
  width: 90%;
  padding: 0 5%;
  height: 100%;
  margin: 0 auto;
  border-left: 2px solid #993333;
  border-right: 2px solid #993333;
}

.mid-box ul{
  display: block;
  width: 20%;
  float: left;
  margin: 0 2.5%;
}

.mid-box ul li{
  font-size: 14px;
  color: #666;
  margin: 15px 0;
  font-weight: 800;
}

.mid-box ul li a{
  text-decoration: none;
  color: inherit;
  font-family: 'Montserrat';
  font-weight: 600
}

.mid-box ul li:nth-child(1){
  font-size: 18px;
  font-weight: bold;
  color: #0B3777;
  margin: 20px 0;
}

.right{
  width: 18%;
  height: 260px;
  float: left;
}

.right-up{
  width: 100%;
  height: 70%;
  overflow: hidden;
  position: relative;
}

.phone{
  width: 100%;
  font-size: 18px;
  color: #7E0000;
  font-weight: bold;
  text-align: center;
  position: absolute;
  left: 50%;
  top: 22%;
  transform: translate(-50%, -50%);
}

.phone2{
  width: 100%;
  font-size: 18px;
  color: #7E0000;
  font-weight: bold;
  text-align: center;
  position: absolute;
  left: 50%;
  top: 33%;
  transform: translate(-50%, -50%);
}

.worktime{
  width: 100%;
  font-size: 16px;
  color: #666666;
  font-weight: bold;
  text-align: center;
  position: absolute;
  left: 50%;
  top: 45%;
  transform: translate(-50%, -50%);
}

.email{
  width: 100%;
  font-size: 16px;
  color: #666666;
  font-weight: bold;
  text-align: center;
  position: absolute;
  left: 50%;
  top: 69%;
  transform: translate(-50%, -50%);
}

.right-bottom{
  width: 100%;
  height: 30%;
  overflow: hidden;
  text-align: center;
}

.right-bottom a{
  display: inline-block;
  font-size: 16px;
  color: #FFF;
  background-color: #7E0000;
  text-align: center;
  width: 150px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  border-radius: 10px;
  cursor: pointer;
  text-decoration: none;
}

.wechat-share{
  position: relative;
}

#qrcode{
  position: absolute;
  bottom: 150%;
  left: 50%;
  transform: translateX(-50%);
  padding: 10px;
  box-shadow: 0px 0px 10px rgba(0,0,0,0.2);
  background-color: #FFF;
}

@media screen and (max-width: 1300px){
  .email{
    font-size: 14px;
  }
}

@media screen and (max-width: 1150px){
  .email{
    font-size: 12px;
  }
}

@media screen and (max-width: 950px){
  .email{
    font-size: 10px;
  }
}

@media screen and (max-width: 920px){
  .middle{
    display: none;
  }
  .left{
    width: 100%;
    height: 180px;
    float: none;
  }
  .left .left-top{
    height: 70%;
  }
  .left .left-imgbox{
    height: 30%;
  }

  .left .left-top img{
    height: 65%;
  }
  .right{
    width: 100%;
    float: none;
  }
  .left .left-imgbox img{
    margin: 12px 3px;
    width: 30px;
    height: 30px;
  }

  .right{
    height: 200px;
  }
  .phone{
    font-size: 18px;
  }

  .worktime{
    font-size: 16px;

  }

  .email{
    font-size: 16px;
  }

  .right-bottom a{
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Layout/LayoutFooter.vue